import { Link } from 'react-router-dom';
import PageSEO from '@/components/feature/PageSEO';
import Footer from '../home/components/Footer';

const SECTION_CLASS = 'space-y-3';
const H2_CLASS = 'text-xl sm:text-2xl font-semibold text-white pt-6';
const P_CLASS = 'text-base text-gray-300 leading-relaxed';
const LI_CLASS = 'text-base text-gray-300 leading-relaxed list-disc ml-6';

export default function PrivacyPolicyPage() {
  return (
    <>
      <PageSEO
        title="Privacy Policy | Nexa Pods Australia"
        description="How Nexa Pods (Da Zang Pty Ltd, ABN 90 634 527 067) collects, uses, and protects your personal information under the Australian Privacy Act 1988."
        canonicalPath="/privacy-policy"
      />
      <div className="bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000] text-white min-h-screen w-full overflow-x-hidden">
        {/* Simple top bar */}
        <nav className="w-full border-b border-cyan-500/10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/images/c719b13a28cc.webp"
                alt="Nexa Pods"
                className="h-12 w-auto"
              />
            </Link>
            <Link to="/" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors">
              ← Back to Home
            </Link>
          </div>
        </nav>

        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">Privacy Policy</h1>
          <p className="text-sm text-gray-500 mb-10">Last updated: 7 July 2026</p>

          <div className="space-y-4">
            <p className={P_CLASS}>
              This Privacy Policy explains how Da Zang Pty Ltd trading as Nexa Pods (ABN 90 634 527 067)
              (&quot;Nexa Pods&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;) collects, holds, uses, and discloses your
              personal information in accordance with the Privacy Act 1988 (Cth) and the Australian
              Privacy Principles (APPs).
            </p>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>1. Information We Collect</h2>
              <p className={P_CLASS}>We may collect the following personal information when you contact us or use our website:</p>
              <ul className="space-y-2">
                <li className={LI_CLASS}>Name, email address, phone number, and company name that you provide through our contact or enquiry forms;</li>
                <li className={LI_CLASS}>Project details you choose to share, such as project location, timeline, and indicative budget;</li>
                <li className={LI_CLASS}>Technical and usage data collected automatically through cookies and analytics tools (such as pages visited, device type, and approximate location).</li>
              </ul>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>2. How We Use Your Information</h2>
              <ul className="space-y-2">
                <li className={LI_CLASS}>To respond to your enquiries and provide quotes and product information;</li>
                <li className={LI_CLASS}>To communicate with you about your project or order;</li>
                <li className={LI_CLASS}>To improve our website, products, and services;</li>
                <li className={LI_CLASS}>To comply with our legal obligations.</li>
              </ul>
              <p className={P_CLASS}>We do not sell your personal information to third parties.</p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>3. Cookies and Analytics</h2>
              <p className={P_CLASS}>
                Our website uses Google Analytics to understand how visitors use the site. Google Analytics
                uses cookies to collect anonymised usage data. You can opt out of Google Analytics by
                installing the Google Analytics opt-out browser add-on, or by disabling cookies in your
                browser settings.
              </p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>4. Disclosure of Personal Information</h2>
              <p className={P_CLASS}>We may disclose personal information to:</p>
              <ul className="space-y-2">
                <li className={LI_CLASS}>Service providers who help us operate our website and process enquiries (such as website hosting and form-processing providers), some of which may store data outside Australia;</li>
                <li className={LI_CLASS}>Professional advisers, contractors, or delivery partners where necessary to fulfil your request;</li>
                <li className={LI_CLASS}>Government or regulatory bodies where required by law.</li>
              </ul>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>5. Storage and Security</h2>
              <p className={P_CLASS}>
                We take reasonable steps to protect your personal information from misuse, interference,
                loss, and unauthorised access, modification, or disclosure. Enquiry data is stored with
                reputable third-party providers that maintain their own security safeguards.
              </p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>6. Access and Correction</h2>
              <p className={P_CLASS}>
                You may request access to, or correction of, the personal information we hold about you at
                any time by contacting us using the details below. We will respond within a reasonable
                period.
              </p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>7. Complaints</h2>
              <p className={P_CLASS}>
                If you believe we have breached the Australian Privacy Principles, please contact us first
                so we can investigate and respond. If you are not satisfied with our response, you may
                lodge a complaint with the Office of the Australian Information Commissioner (OAIC) at
                www.oaic.gov.au.
              </p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>8. Contact Us</h2>
              <p className={P_CLASS}>Da Zang Pty Ltd trading as Nexa Pods (ABN 90 634 527 067)</p>
              <p className={P_CLASS}>218/89 High Street, Kew VIC 3101, Australia</p>
              <p className={P_CLASS}>Phone: +61 3 9008 6321</p>
              <p className={P_CLASS}>Email: info@nexapods.com.au</p>
            </section>

            <section className={SECTION_CLASS}>
              <h2 className={H2_CLASS}>9. Changes to This Policy</h2>
              <p className={P_CLASS}>
                We may update this Privacy Policy from time to time. The latest version will always be
                available on this page with the date of the most recent update.
              </p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}
